import { HotelConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "src/components/shared/TravelersField";

export const hotelConfig: HotelConfig = {
  navigation: {
    tabIcon: "lob_hotels",
    tabTitleToken: "wizard.hotel.tab.title.label",
  },
  lastSearch: {
    useLastSearchForSingleLOB: false,
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-hotel-pwa",
  },
  location: {
    destination: {
      inputName: "destination",
      icon: "place",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      invalidOriginSameAsDestinationKey: "",
      labelToken: "wizard.hotel.destination.label",
      typeaheadLabelToken: "wizard.typeahead.placeholder.title.hotel",
      typeaheadEmptyResultPlaceholder: "wizard.typeahead.placeholder.emptyResultPlaceholder.hotel",
      pwaDialogQueryParam: "destination-hotel",
      essAdapterConfig: {
        lob: "HOTELS",
        client: "Homepage",
        features: "ta_hierarchy|postal_code|google|consistent_display",
        maxResults: 8,
        regionType: 2047,
        dest: true,
      },
      queryParams: {
        regionId: "regionId",
        latLong: "latLong",
      },
    },
    origin: {
      inputName: "origin",
      icon: "place",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      labelToken: "wizard.flight.origin.label",
      typeaheadLabelToken: "wizard.typeahead.placeholder.title.package.origin",
      typeaheadEmptyResultPlaceholder: "wizard.typeahead.placeholder.emptyResultPlaceholder.flight",
      pwaDialogQueryParam: "origin-flight",
      essAdapterConfig: {
        lob: "FLIGHTS",
        client: "Homepage",
        features: "nearby_airport|ta_hierarchy|consistent_display",
        maxResults: 8,
        regionType: 351,
        dest: false,
      },
    },
  },
  locationFlight: {
    origin: {
      inputName: "",
      icon: "",
      invalidLocationMessageKey: "",
      labelToken: "",
      typeaheadLabelToken: "wizard.flight.origin.placeholder",
      pwaDialogQueryParam: "",
      essAdapterConfig: {
        lob: "",
        client: "",
        features: "",
        maxResults: 8,
        regionType: 0,
        dest: false,
      },
    },
  },
  date: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    softPackage: {
      daysBookableInAdvance: 331,
    },
    midnightBookingOffset: 4,
    maxDaysRange: 28,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidFromDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidToDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    start: {
      labelToken: "datePicker.fromDate.label",
    },
    end: {
      labelToken: "datePicker.toDate.label",
    },
    queryParam: {
      start: "startDate",
      end: "endDate",
    },
    defaultOffsetDates: {
      start: 14,
      end: 15,
    },
    dialogId: "check-in-out",
  },
  travelers: {
    icon: "person",
    labelToken: "wizard.roomPicker.travelers.title",
    dialogTitleToken: "wizard.roomPicker.travelers.title",
    dialogCancelLabelToken: "wizard.roomPicker.closeButton.a11yLabel",
    childrenCaptionToken: "wizard.roomPicker.children.caption",
    infantsCaptionToken: "",
    youngestChildAgeTextToken: "wizard.roomPicker.youngestChildAge.text",
    youngestInfantAgeTextToken: "",
    invalidLessThanNTravelersMessageToken: "wizard.travelers.warning.invalidNumberOfTravelers.text",
    invalidUnattendedInfantOnLapMessageToken: "",
    singleTravelerToken: "wizard.roomPicker.singleTraveler",
    multipleTravelersToken: "wizard.roomPicker.multipleTravelers",
    singleRoomSingleGuestToken: "wizard.roomPicker.singleRoomSingleGuest",
    singleRoomMultipleGuestsToken: "wizard.roomPicker.singleRoomMultipleGuests",
    multipleRoomsMultipleGuestsToken: "wizard.roomPicker.multipleRoomsMultipleGuests",
    minBookableTravelers: 1,
    defaultTravelers: 2,
    maxBookableTravelers: 14,
    minChildAge: 0,
    maxChildAge: 17,
    minInfantAge: 0,
    maxInfantAge: 1,
    minAdultsPerRoom: 1,
    maxAdultsPerRoom: 14,
    minChildrenPerRoom: 0,
    maxChildrenPerRoom: 6,
    minInfantsPerRoom: 0,
    maxInfantsPerRoom: 0,
    maxRooms: 8,
    withRooms: true,
    withAges: true,
    withFlight: false,
    withInfants: false,
    hiddenInputType: TRAVELERS_HIDDEN_INPUT_TYPE.HOTEL_SEARCH,
  },
  form: {
    action: "/Hotel-Search",
    actionPackage: "/flexibleshopping",
    submitButton: {
      locToken: "wizard.submit.label",
      locWarningToken: "wizard.submit.warning",
      locWarningLinkToken: "wizard.submit.warning.link",
      locMultipleWarningsToken: "wizard.submit.warnings",
      locMultipleWarningsLinkToken: "wizard.submit.warnings.link",
    },
  },
  heading: {
    fixedTitle: false,
    lobSubtitleBreakPoint: "off",
    locTitleToken: "wizard.mobile.label.hotel",
  },
  desktopAutoOpenCalendar: false,
  elementId: "wizard-hotel-pwa",
  enableAddCar: false,
  enableAddFlight: false,
  enablePackageRates: false,
  percentSave: 20,
  packageRatesTermsUrl: "",
  includeFiltersHotelPWAWizard: false,
  enableMultiplePlaces: false,
  useDialogTextWithoutCar: false,
  showDestinationField: true,
  siteIdsWithoutSoftPackages: [],
  hotelName: "",
  hotelID: "",
  hotelChainID: "",
  multiHotelIDs: undefined,
  isBiasedWizardEmpty: true,
};
